module.exports = __webpack_public_path__ + "static/img/logo5.c7a1adf4.png";